module.exports = __webpack_public_path__ + "static/img/login_background.c0fb3d50.webp";